const tmb_voccabulaire = {
    category: {
        en: "Catégorie",
        fr: "Catégorie"
    },
    objet: {
        en: "Objet",
        fr: "Objet"
    },
    reason: {
        en: "Raison",
        fr: "Raison"
    },
    sub_reason: {
        en: "Raison",
        fr: "Raison"
    },
    reason_need: {
        en: "Raison",
        fr: "Raison"
    },
    category_monetique: {
        en: "Monétique",
        fr: "Monétique"
    },
    objet_carte: {
        en: "Carte",
        fr: "Carte"
    },
    objet_demande_carte: {
        en: "Carte",
        fr: "Carte"
    },
    category_tmb_demandes: {
        en: "Demandes",
        fr: "Demandes"
    },
    category_reclamation: {
        en: "Reclamation",
        fr: "Reclamation"
    },
    objet_tpe_marchand: {
        en: "TPE / Marchand",
        fr: "TPE / Marchand"
    },
    objet_reclamations_financieres: {
        en: "Reclamation financieres",
        fr: "Reclamation financieres"
    },
    objet_application: {
        en: "Applications",
        fr: "Applications"
    },
    reason_applications: {
        en: "Applications",
        fr: "Applications"
    },
    objet_autres: {
        en: "Autres",
        fr: "Autres"
    },
    reason_autres: {
        en: "Autres",
        fr: "Autres"
    },
    reason_rejet_atm: {
        en: "Rejet ATM",
        fr: "Rejet ATM"
    },
    sub_reason_rejet_technique: {
        en: "Rejet technique",
        fr: "Rejet technique"
    },
    reason_rejet_tpe: {
        en: "Rejet TPE",
        fr: "Rejet TPE"
    },
    reason_rejet_en_ligne: {
        en: "Rejet en ligne",
        fr: "Rejet en ligne"
    },
    reason_rejet_carte: {
        en: "Rejet Carte",
        fr: "Rejet Carte"
    },
    reason_probleme_de_connexion: {
        en: "Problème de connexion",
        fr: "Problème de connexion"
    },
    reason_probleme_de_batterie: {
        en: "Problème de batterie",
        fr: "Problème de batterie"
    },
    reason_debit_a_tort: {
        en: "Débit à tort",
        fr: "Débit à tort"
    },
    reason_transaction_non_percue: {
        en: "Transaction non perçue",
        fr: "Transaction non perçue"
    },
    reason_double_prelevement: {
        en: "Double prélèvement",
        fr: "Double prélèvement"
    },
    sub_reason_atm: {
        en: "ATM",
        fr: "ATM"
    },
    sub_reason_tpe: {
        en: "TPE",
        fr: "TPE"
    },
    sub_reason_en_ligne: {
        fr: "En ligne",
        en: "En ligne"
    },
    reason_netbank: {
        en: "Netbank",
        fr: "Netbank"
    },
    reason_pepele: {
        en: "Pepele",
        fr: "Pepele"
    },
    sub_reason_netbank: {
        en: "Netbank",
        fr: "Netbank"
    },
    sub_reason_pepele: {
        en: "Pepele",
        fr: "Pepele"
    },
    sub_reason_acces_impossible: {
        en: "Accès impossible",
        fr: "Accès impossible"
    },
    sub_reason_pay_secure: {
        en: "Pay secure",
        fr: "Pay secure"
    },
    sub_reason_rejet_transaction: {
        en: "Rejet transaction",
        fr: "Rejet transaction"
    },
    sub_reason_echec_reception_notification: {
        en: "Echec de réception notification",
        fr: "Echec de réception notification"
    },
    reason_need_activation: {
        en: "Activation",
        fr: "Activation"
    },
    reason_need_desactivation: {
        en: "Désactivation",
        fr: "Désactivation"
    },
    reason_need_reactivation: {
        en: "Réactivation",
        fr: "Réactivation"
    },
    reason_need_mise_en_opposition: {
        en: "Mise en opposition",
        fr: "Mise en opposition"
    },
    reason_need_rechargement: {
        en: "Rechargement",
        fr: "Rechargement"
    },
    reason_need_transfert_de_solde: {
        en: "Transfert de solde",
        fr: "Transfert de solde"
    },
    reason_need_demande_releve: {
        en: "Demande relevé",
        fr: "Demande relevé"
    },
    reason_need_changement_de_compte: {
        en: "Changement de compte",
        fr: "Changement de compte"
    },
    reason_need_changement_n0_tel: {
        en: "Changement de numéro de téléphone",
        fr: "Changement de numéro de téléphone"
    },
    reason_need_changement_n0tel: {
        en: "Changement de numéro de téléphone",
        fr: "Changement de numéro de téléphone"
    },
    reason_need_enrolement_3d_secure: {
        en: "Enrôlement 3D Secure",
        fr: "Enrôlement 3D Secure"
    },
    reason_need_modification_plafond: {
        en: "Modification plafond",
        fr: "Modification plafond"
    },
    reason_need_emission_nouveau_code_pin: {
        en: "Emission nouveau code PIN",
        fr: "Emission nouveau code PIN"
    },
    reason_need_paiement_facture: {
        en: "Paiement Facture",
        fr: "Paiement Facture"
    },
    reason_need_changement_modalites_remboursement: {
        en: "Changement modalités de remboursement",
        fr: "Changement modalités de remboursement"
    },
    reason_need_nouvelle_carte: {
        en: "Nouvelle carte",
        fr: "Nouvelle carte"
    },
    reason_need_renouvellement_de_carte: {
        en: "Renouvellement de carte",
        fr: "Renouvellement de carte"
    },
    reason_need_remplacement_de_carte: {
        en: "Remplacement de carte",
        fr: "Remplacement de carte"
    },
    sub_reason_rouleau: {
        en: "Rouleau",
        fr: "Rouleau"
    },
    sub_reason_chargeur: {
        en: "Chargeur",
        fr: "Chargeur"
    },
    sub_reason_tpe_additionnel: {
        en: "TPE additionnel",
        fr: "TPE additionnel"
    },
    sub_reason_fonction_additionnelle: {
        en: "Fonction additionnelle",
        fr: "Fonction additionnelle"
    },
    reason_need_reinitialisation: {
        en: "Réinitialisation",
        fr: "Réinitialisation"
    },
    reason_need_credit_access: {
        en: "Crédit Access",
        fr: "Crédit Access"
    },
    reason_need_ajout_nouvel_utilisateur: {
        en: "Ajout nouvel utilisateur",
        fr: "Ajout nouvel utilisateur"
    },
    reason_need_modification_profil: {
        en: "Modification profil",
        fr: "Modification profil"
    },
    reason_need_creation_acces: {
        en: "Création Accès",
        fr: "Création Accès"
    },
    reason_need_desactivation: {
        en: "Désactivation",
        fr: "Désactivation"
    },
    sub_reason_prepaye: {
        en: "Prépayé",
        fr: "Prépayé"
    },
    sub_reason_debit: {
        en: "Débit",
        fr: "Débit"
    },
    sub_reason_credit: {
        en: "Crédit",
        fr: "Crédit"
    },
    reason_commande: {
        en: "Commande",
        fr: "Commande"
    },
    reason_gestion: {
        en: "Gestion",
        fr: "Gestion"
    },
    reason_blocage: {
        en: "Blocage",
        fr: "Blocage"
    },
    
    category_others: {
        en: "Autres",
        fr: "Autres"
    },
    form_field_nom: {
        en: "",
        fr: ""
    },
    form_field_prenom: {
        en: "",
        fr: ""
    },
    form_field_telephone: {
        en: "",
        fr: ""
    },
    form_field_agence: {
        en: "",
        fr: ""
    },
    form_field_numero_compte: {
        en: "",
        fr: ""
    },
    form_field_type_carte: {
        en: "",
        fr: ""
    },
    form_field_numero_cart: {
        en: "",
        fr: ""
    },
    form_field_date_transaction: {
        en: "",
        fr: ""
    },
    form_field_heure_transaction: {
        en: "",
        fr: ""
    },
    form_field_montant_transaction: {
        en: "",
        fr: ""
    },
    form_field_destinataire_transaction: {
        en: "",
        fr: ""
    },
    form_field_numero_tmb: {
        en: "",
        fr: ""
    },
    form_field_reference: {
        en: "",
        fr: ""
    },

}

export default tmb_voccabulaire
